import Vue from 'vue'
import util from '@/util'

Vue.filter('truncate', function (text, stop, clamp) {
  return util.truncate(text,stop,clamp);
})
Vue.filter('trim', function (str) {
  if (!str) {return ''}  
  return str.trim()
})
Vue.filter('formatRouteName', function (name) {
  return util.formatRouteName(name);
})
Vue.filter('timestampToDate', function (timestamp) {
  return util.timestampToDate(timestamp);
})
